module.exports = __webpack_public_path__ + "img/coding.2c42bdd1.svg";